import isFalsy from '../helpers/is-falsy';
import isTruthy from '../helpers/is-truthy';

const projectAssignments = {
  'Member Email': {
    requirementType: 'required',
    description:
      'The email address of the member to assign. This must match the email of an existing workspace member.',
    dataType: 'email',
    validator: (value) => value.trim() !== '' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim()),
  },
  'Client Name': {
    requirementType: 'required',
    description:
      'The name of the client associated with the project. This field must match the name of a client exactly, including spaces, punctuation and capitalization, otherwise the row may be skipped during import.',
    dataType: 'string',
    validator: (value) => value.trim() !== '',
  },
  'Project Name': {
    requirementType: 'required',
    description:
      'The name of the project to assign the member to. This field must match the name of a project exactly, including spaces, punctuation and capitalization, otherwise the row may be skipped during import.',
    dataType: 'string',
    validator: (value) => value.trim() !== '',
  },
  'Role Name': {
    requirementType: 'optional',
    description:
      'The name of the project role to assign the member to. If omitted, the member is assigned without a specific role.',
    dataType: 'string',
    validator: () => true,
  },
  'Role Billable': {
    requirementType: 'optional',
    description: '"Yes" or "No" to indicate whether the role is billable. Leave blank to use the project default.',
    dataType: 'boolean',
    validator: (value) => {
      return !value || isTruthy(value) || isFalsy(value);
    },
  },
  'Role Rate': {
    requirementType: 'optional',
    description: 'The billable rate for the role. This value will be ignored if the role is non-billable.',
    dataType: 'number',
    validator: (value) => {
      return !value || (!isNaN(parseFloat(value)) && isFinite(value) && Number(value) >= 0);
    },
  },
  'Member Billable': {
    requirementType: 'optional',
    description:
      '"Yes" or "No" to indicate whether the member is billable on this project. Leave blank to use the role default.',
    dataType: 'boolean',
    validator: (value) => {
      return !value || isTruthy(value) || isFalsy(value);
    },
  },
  'Task Name': {
    requirementType: 'optional',
    description:
      'The name of a task to assign the member to. The name must match an existing task on the project exactly, including spaces, punctuation and capitalization.',
    dataType: 'string',
    validator: () => true,
  },
  'Task Assignment Hours': {
    requirementType: 'optional',
    description: 'The number of hours to allocate to the member for the specified task.',
    dataType: 'number',
    validator: (value) => {
      return !value || (!isNaN(parseFloat(value)) && isFinite(value) && Number(value) >= 0);
    },
  },
};

export default projectAssignments;
